import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Account, AccountResource, AddressEntity, AddressResource } from '@apaq/orgkit-js';
import { ContextService } from 'ngx-orgkit';
import { CustomValidators } from 'src/app/common/validation/custom-validators';
import { container } from 'tsyringe';

declare var window: Window & {
  __passport_control__: {
    host: string
  }
};


@Component({
  selector: 'app-profile-editor-view',
  templateUrl: './profile-editor-view.component.html',
  styleUrls: ['./profile-editor-view.component.scss']
})
export class ProfileEditorViewComponent {

  form: FormGroup;
  searchedAddresses: AddressEntity[] = [];

  constructor(private fb: FormBuilder,
    private context: ContextService,
    private accountResource: AccountResource) {
    this.form = this.fb.group({
      id: [''],
      name: ['', [Validators.required]],
      street: ['', [Validators.required]],
      postalCode: ['', [Validators.required]],
      city: ['', [Validators.required]],
      countryCode: ['', [Validators.required]],
      apartment: [''],
      phone: ['', [CustomValidators.phone()]],
      email: ['', [Validators.required, Validators.email]],
      location: [[]]
    });

    this.load();
  }

  get passportApiUrl() {
    return window.__passport_control__?.host ?? 'http://localhost:9000'
  }
  
  async onPrimaryEmailChange(event: CustomEvent) {
    const email = event.detail;
    await this.accountResource.save({id: this.context.account.id, email} as Account);
    this.context.reloadAccount();
  }

  async load() {
    this.form.patchValue(await this.accountResource.findById(this.context.account.id));
    this.form.markAsPristine();
  }

  async submit() {
    const account = this.form.value as Account;
    const persistedOrg = await this.accountResource.save(account);
  
    this.form.patchValue(persistedOrg);
    this.form.reset(this.form.value);
    this.context.reloadAccount();

  }
}
